import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 24px;
`;

class Page404 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {}
  }

  componentDidMount() {
    if (this.props.setMode) {
      this.props.setMode('basic');
    }
  }

  render() {
    return (
      <Wrapper>
        <Text1>404 Not Found</Text1>
        <Text2>
          The current page does not exist.
        </Text2>
      </Wrapper>
    );
  }

}

export default Page404;



// WEBPACK FOOTER //
// ./src/components/onboarding/Page404.js